import { PlaceholderSpan } from '../PlaceholderSpan'

export const HtmlIfFunction = () => (
  <>
    <span
      data-description="Click to change function"
      data-function="if"
      data-type="function"
    >
      IF
    </span>
    <span data-type="parentheses">(</span>
    <PlaceholderSpan
      data-description="Click and type a condition"
      placeholderProps={{ description: 'add condition' }}
      valueProps={{
        dataDescription: 'Click and type to add a value when true',
        'data-type': 'condition',
        'data-order': '3',
      }}
    />
    <span data-type="semicolon">;</span>
    <PlaceholderSpan
      data-description="Click and type to add a value when true"
      placeholderProps={{
        description: 'value when true',
        'data-color': 'green',
      }}
      valueProps={{
        dataDescription: 'Click and type to add a value when true',
        'data-type': 'whenTrue',
        'data-order': '4',
      }}
    />

    <span data-type="semicolon">;</span>
    <PlaceholderSpan
      data-description="Click and type to add a value when false"
      placeholderProps={{
        description: 'value when false',
        'data-color': 'red',
      }}
      valueProps={{
        dataDescription: 'Click and type to add a value when false',
        'data-type': 'whenFalse',
        'data-order': '5',
      }}
    />
    <span data-type="parentheses">)</span>
  </>
)
